import { DetailedCartItem } from 'hooks/context/cart';
import { ServiceTypeData } from 'hooks/context/serviceType/models';
import { GiftCardItem, TableDetails, TableOrder } from 'olo-service/models';
import { formatRequest } from 'olo-service/Order';
import { useMutation, useQueryClient } from 'react-query';
import { isSlug } from './isSlug';
import { useColoAxiosInstance } from './useColoRequest';
import { TABLE_KEYS } from './useTableDetailsResource';

type PutTableOrderMutationArgs = {
  request: PutTableOrderRequest;
  captchaToken?: RecaptchaToken;
};

type PutTableOrderRequest = {
  tipValue: number;
  cartItems: DetailedCartItem[];
  giftCards: GiftCardItem[];
  note?: string;
  globalCustomerUuid?: string;
  typeMetadata: ServiceTypeData;
};

export function usePutTableOrders(merchantId?: string, tableId?: string) {
  const axios = useColoAxiosInstance();
  const tableKey = TABLE_KEYS.table(merchantId, tableId);
  const queryClient = useQueryClient();

  return useMutation(
    async ({ request, captchaToken }: PutTableOrderMutationArgs) => {
      const response = await axios.put<TableOrder>(
        `${merchantId}/tables/${tableId}/order`,
        {
          ...formatRequest(request),
        },
        {
          headers: {
            'X-Captcha-Token': captchaToken,
          },
          params: { slug: isSlug(merchantId) },
        }
      );

      return response.data;
    },
    {
      onSuccess: (data) => {
        queryClient.setQueryData<TableDetails>(tableKey, (old) => ({
          ...old,
          order: data as any
        }));
      },
      onSettled: () => {
        queryClient.invalidateQueries(tableKey);
      },
    }
  );
}
